/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useReduxAuth} from '../../../../app/modules/auth/useReduxAuth'
import {toAbsoluteUrl} from '../../../helpers'
import { useLogout } from '../../../hooks/useLogout'

const HeaderUserMenu: FC = () => {
  const {user: currentUser} = useReduxAuth()
  const { performLogout } = useLogout()

  const onClickLogout = () => {
    performLogout()
  }

  const truncateText = (text: string, length = 20) => {
    if (!text) return ''
    return text.length > length ? text.slice(0, length) + '...' : text
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-2 pe-1'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/avatars/blank.png')}
              className='rounded-circle'
            />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.fullName || currentUser?.full_name}
            </div>
            <span>{truncateText(currentUser?.email)}</span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5 my-1'>
        <Link to='/account' className='menu-link px-5'>
          Account Settings
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to='/' onClick={onClickLogout} className='menu-link px-5'>
          Sign Out
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
